import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'reflect-metadata';

import { CircularProgress } from "@mui/material";

import BaseLayout from "./BaseLayout";
import StudentList from "../../screens/student/StudentList";
import ChangePasswordPage from "../../screens/auth/ChangePasswordPage";
import CasesListPage from "../../screens/cases/CasesListPage";
import CreateCasePage from "../../screens/cases/CreateCasePage";
import StudentDetails from "../../screens/student/StudentDetails";
import PaymentsPage from "../../screens/payment/PaymentsPage";
import CaseDetailPage from "../../screens/cases/CaseDetailPage";
import CreatePaymentPage from "../../screens/payment/CreatePaymentPage";
import AgreemantPage from "../../screens/student/AgreemantPage";
import Login from "../../screens/auth/Login";
import PasswordRecovery from "../../screens/auth/PasswordRecovery";
import {UserStore} from "../../screens/auth/UserStore";
import ProfilePage from "../../screens/profile/ProfilePage";
import InstallPwaDialog from "./InstallPwaDialog";
import IosPwaPrompt from "./IosPwaPromt";
import AboutPage from "../../screens/profile/AboutApp";
import AnnouncementsPage from "../../screens/announcements/AnnouncementsPage";
import AnnouncementDetailPage from "../../screens/announcements/AnnouncementDetailPage";
import TripDetailPage from "../../screens/trips/TripDetailPage";
import { messagingReady, VAPID_KEY } from "../../firebaseConfig";
import { getToken } from "firebase/messaging";
import ApiService from "../../base/api/ApiService";

async function registerFcmToken() {
    try {
        if (!('Notification' in window) || !('serviceWorker' in navigator)) return;
        // FCM требует HTTPS (кроме localhost)
        if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') return;
        const messaging = await messagingReady;
        if (!messaging) return;
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;
        const swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        await navigator.serviceWorker.ready;
        const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swRegistration });
        if (token) {
            console.log('%c[FCM Token]', 'color: #fd5508; font-weight: bold', token);
            await ApiService.registerDeviceToken(token, 'web');
        }
    } catch (e) {
        console.error('FCM token registration failed:', e);
    }
}

const ClientRouter: React.FC = () => {
    const [isAuth, setIsAuth] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const initApp = async () => {
            const userStore = new UserStore();
            await userStore.initApp();
            setIsAuth(userStore.isAuth);
            setIsLoading(false);
            if (userStore.isAuth) {
                registerFcmToken();
            }
        };

        initApp();
    }, []);

    if (isLoading) {
        return <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20%' }}><CircularProgress /></div>;
    }

    return (
        <Router>
            <Routes>
                {isAuth ? (
                    <Route path="/" element={<BaseLayout/>}>
                        <Route path="login" element={<Navigate replace to="/"/>}/>
                        <Route path="password-recovery" element={<Navigate replace to="/"/>}/>
                        <Route index element={<StudentList/>}/>
                        <Route path="/" element={<StudentList/>}/>
                        <Route path="profile" element={<ProfilePage/>}/>
                        <Route path="students" element={<StudentList/>}/>
                        <Route path="cases" element={<CasesListPage/>}/>
                        <Route path="changePassword" element={<ChangePasswordPage/>}/>
                        <Route path="cases/:id" element={<CaseDetailPage/>}/>
                        <Route path="createcase" element={<CreateCasePage/>}/>
                        <Route path="students/:studentId" element={<StudentDetails/>}/>
                        <Route path="payments" element={<PaymentsPage/>}/>
                        <Route path="students/:studentId/payments" element={<PaymentsPage/>}/>
                        <Route path="students/:studentId/createpayment" element={<CreatePaymentPage/>}/>
                        <Route path="agreement" element={<AgreemantPage/>}/>
                        <Route path="aboutApp" element={<AboutPage/>}/>
                        <Route path="announcements" element={<AnnouncementsPage/>}/>
                        <Route path="announcements/:id" element={<AnnouncementDetailPage/>}/>
                        <Route path="trips/:tripId" element={<TripDetailPage/>}/>
                    </Route>
                ) : (
                    <>
                        <Route path="/login" element={<Login/>}/>
                        <Route path="/password-recovery" element={<PasswordRecovery/>}/>
                        <Route path="/agreement" element={<AgreemantPage/>}/>
                        <Route path="*" element={<Navigate replace to="/login"/>}/>
                    </>
                )}
            </Routes>
            <InstallPwaDialog/>
            <IosPwaPrompt/>
        </Router>
    );
};

export default ClientRouter;
